export default __webpack_public_path__ + "static/media/fonts/googleMeet.6f26cfb5.svg";